"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _browserSymbol = _interopRequireDefault(require("svg-baker-runtime/browser-symbol"));

var _sprite = _interopRequireDefault(require("../sprite"));

var _SvgIcon = _interopRequireDefault(require("../SvgIcon"));

var _react = _interopRequireDefault(require("react"));

var _es6ObjectAssign = _interopRequireDefault(require("es6-object-assign"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var viewBox = '0 0 44 44';
var id = 'spinner_44';
var content = '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="spinner_44"><path d="M22 44a1.5 1.5 0 0 1 0-3c10.493 0 19-8.507 19-19S32.493 3 22 3 3 11.507 3 22c0 2.208.376 4.363 1.103 6.397a1.5 1.5 0 1 1-2.825 1.01A21.964 21.964 0 0 1 0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22z" fill="currentColor" fill-rule="nonzero" /></symbol>';
var browserSymbol = new _browserSymbol.default({
  id: id,
  viewBox: viewBox,
  content: content
});

_sprite.default.add(browserSymbol);

var width = 44;
var height = 44;

function Icon(props) {
  return _react.default.createElement(_SvgIcon.default, _es6ObjectAssign.default.assign({}, props, {
    width: width,
    height: height,
    viewBox: viewBox,
    id: id
  }));
}

var _default = Icon;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vkontakte/icons/dist/44/spinner.js
// module id = 398
// module chunks = 0